<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>
<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated" [activationErrors]="activationService.activateErrors"
    [entityName]="account!.name" [activationService]="activationService"></prox-activation-checklist>
  <h5 class="card-header">
    <div class="flex flex-row items-center">
      <span>{{formTitle}}</span>
      <p-button (click)="editAsUser()" [disabled]="isBeingAdded" [label]="getAccountUserEditLabel()"
        styleClass="ml-6"></p-button>
      <p-button *ngIf="linkedAccountUser===undefined" (click)="linkUser()" [disabled]="isBeingAdded"
        label="Find Linked Account User" styleClass="ml-2"></p-button>
      <span *ngIf="!isBeingAdded" class="qb-status-message">{{statusMessage()}}</span>
    </div>
  </h5>
  <div class="qb-content-card w-full h-fit !grow-0" *ngIf="isPageReady">
    <div class="qb-detail-card w-2/3 h-fit">
      <prox-user-frm [proximityUser]="proximityUser!" [isBeingAdded]="isBeingAdded" [roles]="allRoles"
        [isReadOnly]="isReadOnly()" [canChangeEmail]="canChangeEmail"></prox-user-frm>
    </div>
  </div>
  <div class="qb-content-card w-full !grow-0 mt-3" *ngIf="isPageReady && canManageTrainingMode">
    <div class="qb-detail-card w-2/3 h-fit">
      <h6 class="qb-group-label">Training Mode</h6>
      <div class="mt-2 mb-3">
        <ng-container *ngIf="isCurrentlyUnlocked; else lockedState">
          <span class="text-green-700 font-semibold">
            <i class="fa-solid fa-lock-open mr-1"></i>
            <ng-container *ngIf="isPermanentlyUnlocked; else timedUnlock">
              Permanently unlocked (no expiration)
            </ng-container>
            <ng-template #timedUnlock>
              Unlocked until {{ accountAdmin.trainingUnlockedUntil | date:'medium' }}
            </ng-template>
          </span>
        </ng-container>
        <ng-template #lockedState>
          <span class="text-amber-700 font-semibold">
            <i class="fa-solid fa-lock mr-1"></i>
            Locked
          </span>
        </ng-template>
      </div>
      <div class="flex flex-row items-end gap-2 mb-2">
        <div class="flex flex-col">
          <label class="text-xs text-gray-600 mb-1">Unlock duration</label>
          <p-select [options]="trainingUnlockOptions" optionLabel="label" optionValue="value"
            [(ngModel)]="trainingUnlockPreset" name="trainingUnlockPreset" class="w-48"></p-select>
        </div>
        <div *ngIf="trainingUnlockPreset === 'custom'" class="flex flex-col">
          <label class="text-xs text-gray-600 mb-1">Custom unlock until</label>
          <p-datepicker [showTime]="true" [(ngModel)]="trainingUnlockCustom" name="trainingUnlockCustom"></p-datepicker>
        </div>
        <p-button label="Unlock" icon="fa-solid fa-lock-open" (click)="applyTrainingUnlock()"></p-button>
        <p-button *ngIf="isCurrentlyUnlocked" label="Lock now" icon="fa-solid fa-lock" severity="secondary"
          (click)="lockTrainingNow()"></p-button>
      </div>
      <p class="text-xs text-gray-600 mt-2">
        Changes take effect when you click Save.
        A locked PAA cannot edit any Account Management page; the API independently blocks writes from a locked or
        expired PAA.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onUndo()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>